import { splashScreenList } from "@components/splash-screen/splash-screen-data";

/** The content for a single splash screen */

/** The props for the splash screen */

/** All the possible view status of a splash screen topic */

/**
 * Determine whether to show the splash screen to user or not.
 * Do not modify the order of the checks unless you are sure about the implications.
 * Current order of checks:
 * - Exclusion check
 * - Start date check
 * - Disallowed features check
 * - Required features check
 * - Role check
 */
export function shouldShowSplashScreen({
  topic,
  userRole,
  company,
  companyFeatures,
  currentDate,
  isProduction
}) {
  const splashScreen = splashScreenList[topic];
  if (splashScreen.shouldExclude && splashScreen.shouldExclude(company)) {
    return false;
  }

  // Don't show the splash screen if:
  // - the splash screen has a start date and
  // - the current date is before the start date and
  // - the environment is production
  const startDate = splashScreen.startDate;
  if (startDate && currentDate < startDate && isProduction) {
    return false;
  }

  // Don't show the splash screen if the company has one of the disallowed features
  if (splashScreen.disallowedFeatures && (!companyFeatures || companyFeatures.some(feature => splashScreen.disallowedFeatures?.includes(feature)))) {
    return false;
  }

  // Don't show the splash screen if the company is missing one of the required features
  if (splashScreen.requiredFeatures && splashScreen.requiredFeatures.length > 0) {
    if (!companyFeatures) {
      return false;
    }
    const hasAllRequiredFeatures = splashScreen.requiredFeatures.every(feature => companyFeatures.includes(feature));
    if (!hasAllRequiredFeatures) {
      return false;
    }
  }
  return splashScreen.allowedRoles.includes(userRole);
}